import { connect } from 'react-redux';
import Uploader from '../components/Uploader';
import _ from 'lodash';

import { changeUpdateN } from '../modules';

const mapStateToProps = state => {
  return {
    updateN: _.get(state, 'imageLibrary.updateN', 0),
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => ({
  updateImages(number) {
    dispatch(changeUpdateN(number));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Uploader);
